<template>
    <a-config-provider :autoInsertSpaceInButton="false" :locale="locale">
        <vuescroll>
            <div class="page" v-if="isPageIndex">
                <header>
                    <div class="nav">
                        <div class="left">
                            <img src="./assets/home/logo.png" />
                            <span>国家烟草质量监督检验中心</span>
                        </div>
                        <div class="right">
                            <!-- <img src="./assets/home/CMA1.png" /> -->
                            <user-info v-if="userInfo.userName" :userName="userInfo.userName"> </user-info>
                        </div>
                    </div>
                    <div class="tab" v-if="false">
                        <div class="content">
                            <router-link to="/home" class="home">首页</router-link>
                            <router-link to="/unit-introduction" class="unit-introduction">单位介绍</router-link>
                            <router-link to="/notification" class="notification">通知公告</router-link>
                            <router-link to="/test-service" class="test-service">检测服务</router-link>
                            <router-link to="/cigarette" class="cigarette">电子烟专区</router-link>
                            <router-link to="/sample" class="sample">控制样</router-link>
                            <router-link to="/query-service" class="query-service">查询服务</router-link>
                        </div>
                    </div>
                </header>

                <main class="page-content">
                    <router-view></router-view>
                </main>

                <footer>
                    <p>
                        <span>地址:郑州市国家高新技术产业开发区翠竹街6号</span>
                        <span>电话:0371-67672608</span>
                        <span>邮箱:ctqtchuiyi@126.com</span>
                        <span>邮编:450001</span>
                    </p>
                    <p>版权所有:国家烟草质量监督检验中心，未经许可，本网站包括图像、图标、文字在内的所有数据不得转载</p>
                </footer>
                <div class="floating-menu">
                    <div class="item" v-for="m of menuitems" :key="m.text" @click="clickItem(m)">
                        <img :src="m.icon" style="width: 18px; height: 18px" />
                        <span>{{ m.text }}</span>
                    </div>
                </div>
            </div>
            <router-view v-else></router-view>
            <a-spin :spinning="spinning"> </a-spin>
        </vuescroll>
    </a-config-provider>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import UserInfo from './components/user-info.vue';
// import service from './utils/service';
import axios from 'axios';
export default {
    name: 'home',

    components: {
        UserInfo
    },

    data() {
        return {
            locale: zhCN,
            timer: null
        };
    },

    created() {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) ?? {};
        this.setUserInfo(userInfo);
        this.keepOnline();
    },

    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },

    watch: {
        isLogin() {
            if (this.isLogin) {
                this.getSampleType();
                this.getDataUsage();
                this.getOtherCategories();
                this.getReportSignature();
                // this.getSampleUnit();
            }
        }
    },

    computed: {
        ...mapState(['userInfo', 'spinning']),
        ...mapGetters(['isLogin']),

        isPageIndex() {
            const route = this.$route.name;
            return !['login', 'register'].includes(route);
        },

        hideHomeTab() {
            const routeMeta = this.$route.meta;
            return routeMeta?.hideHomeTab;
        },

        menuitems() {
            const m = [
                // {
                //     icon: require('./assets/home/login.svg'),
                //     text: '登录/注册',
                //     id: 'login'
                // },
                // {
                //     icon: require('./assets/home/在线委托.svg'),
                //     text: '在线委托',
                //     id: 'test-service-online-delegation'
                // },
                {
                    icon: require('./assets/home/在线咨询.svg'),
                    text: '在线咨询'
                }
                // {
                //     icon: require('./assets/home/报告查询.svg'),
                //     text: '报告查询'
                // }
            ];
            // if (this.isLogin) {
            //     m.shift();
            // }
            return m;
        }
    },

    methods: {
        ...mapActions(['getSampleType', 'getDataUsage', 'getOtherCategories', 'getReportSignature']),

        ...mapMutations(['setUserInfo', 'changeSpinning']),

        ...mapActions('testService', ['createOnlineFolders']),

        async clickItem(m) {
            if (m.id === 'test-service-online-delegation') {
                this.changeSpinning(true);
                const folderId = (await this.createOnlineFolders()).data;
                const params = {
                    folderId
                };
                this.$router.push({ name: 'test-service-online-delegation', query: params });
                this.changeSpinning(false);
                return;
            }

            this.$router.push({ name: m.id });
        },

        keepOnline() {
            this.timer = setInterval(async () => {
                await axios.get(`/core/module/sys/statuses/speed`);
            }, 1000 * 30);
        }
    }
};
</script>

<style lang="scss">
.page {
    min-width: 1200px;
    min-height: 100%;
    font-size: 14px;
    color: #333333;
    overflow: hidden;

    header {
        width: 100%;
        background: #e6f2ff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .nav {
            width: 1200px;
            height: 64px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                display: flex;
                align-items: center;

                img {
                    width: 56px;
                }

                span {
                    margin-left: 16px;
                    font-size: 24px;
                    color: #005299;
                    font-weight: 700;
                }
            }

            .right {
                display: flex;
                align-items: center;
            }
        }

        .tab {
            width: 100%;
            height: 48px;
            background: #005299;
            display: flex;
            justify-content: center;

            .content {
                width: 1200px;
                height: 100%;
                line-height: 48px;

                a {
                    display: inline-block;
                    padding: 0 32px;
                    font-size: 20px;
                    color: #ffffff;
                    font-weight: 600;
                    text-align: center;
                    border-right: 1px solid #003c80;

                    &:hover {
                        background: rgba($color: #000000, $alpha: 0.2);
                    }

                    &.router-link-active {
                        background: #0099db;
                    }

                    &::before {
                        content: 'ww';
                        color: transparent;
                        user-select: none;
                        display: inline-block;
                    }

                    &.home::before {
                        background: url(./assets/home/home.svg) no-repeat center;
                    }

                    &.unit-introduction::before {
                        background: url(./assets/home/unit-introduction.svg) no-repeat center;
                    }

                    &.notification::before {
                        background: url(./assets/home/notification.svg) no-repeat center;
                    }

                    &.test-service::before {
                        background: url(./assets/home/test-service.svg) no-repeat center;
                    }

                    &.cigarette::before {
                        background: url(./assets/home/cigarette.svg) no-repeat center;
                    }

                    &.sample::before {
                        background: url(./assets/home/sample.svg) no-repeat center;
                    }

                    &.query-service::before {
                        background: url(./assets/home/query-service.svg) no-repeat center;
                    }
                }
            }
        }
    }

    main {
        background: #f4f6f8;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    footer {
        width: 100%;
        height: 128px;
        background: #005299;
        color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
            span {
                margin-right: 48px;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .floating-menu {
        position: fixed;
        right: 48px;
        bottom: 100px;
        width: 70px;
        background: #ebf2f9;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
        padding-top: 8px;
        border-radius: 4px;
        border-top: 4px solid #005299;

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 6px;
            &:hover {
                background: rgba(0, 82, 153, 0.3);
            }
            span {
                font-size: 12px;
                color: #333333;
                letter-spacing: 0;
                line-height: 18px;
                font-weight: 600;
            }
        }
    }

    .search-page {
        width: 100%;
        background: #ffffff;
        border-radius: 4px;
        padding: 16px 24px;
        min-height: 664px;
        .title {
            height: 48px;
            font-size: 24px;
            font-weight: 600;
            letter-spacing: 0;
            color: #005299;
            background: url(./assets/test-service/split.png) bottom no-repeat;
        }

        .search-input {
            height: 80px;
            padding: 0 8px;
            display: flex;
            align-items: center;

            .ant-btn-lg {
                height: 48px;
                background: #005299;
                border: 1px solid rgba(0, 82, 153, 1);
                border-radius: 0px 4px 4px 0px;
                font-size: 18px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
                font-weight: 600;
                padding: 0 30px;
            }
        }

        .search-content {
            width: 100%;

            padding: 0 8px;
            .nav {
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e2e2e2;
                background: #fbfcff;
                padding: 0 16px;

                .left {
                    font-weight: 600;
                }

                .right {
                    cursor: pointer;

                    &::after {
                        content: '>';
                        margin-left: 4px;
                    }
                }
            }

            .content {
                background: #fbfcff;
                ::v-deep {
                    .custom-form {
                        padding-top: 22px;
                    }
                }

                position: relative;

                .ant-btn-link {
                    position: absolute;
                    right: 100px;
                    bottom: 27px;
                }
            }
        }
    }

    .ant-input-lg {
        height: 48px;
        padding: 13px 16px;
    }

    .ant-btn {
        border: 1px solid rgba(0, 82, 153, 1);
        border-radius: 4px;
        font-size: 14px;
        color: #005bac;
        letter-spacing: 0;
        text-align: center;

        &.ant-btn-primary {
            background: #005299;
            color: #fff;
            border-color: #005299;
        }

        &.ant-btn-link {
            color: #1890ff;
            background-color: transparent;
            border-color: transparent;
            box-shadow: none;
        }
    }

    .ant-table-thead {
        > tr {
            > th {
                background: #fff;
                border-bottom: 4px solid rgba(0, 102, 255, 0.15);
            }
        }
    }

    .ant-table-tbody {
        background: #fbfcff;
        > tr {
            > td {
                border-bottom: 1px solid #cde2ff;
            }
        }
    }

    .ant-breadcrumb {
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        margin: 16px 0;
        width: 100%;
        > span:last-child {
            color: #333333;
        }

        a {
            color: #005299;

            &:hover {
                color: rgba($color: #005299, $alpha: 0.7);
            }
        }

        .ant-breadcrumb-separator {
            color: #999999;
        }
    }

    .ant-steps {
        .ant-steps-item-icon {
            width: 54px;
            height: 54px;
            border: none;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 600;

            .ant-steps-icon {
                display: flex;
                border-radius: 50%;
                width: 100%;
                height: 100%;
                transform: scale(0.81);
                align-items: center;
                justify-content: center;
            }
        }

        .ant-steps-item-process {
            .ant-steps-item-icon {
                background: #d8eaff;

                .ant-steps-icon {
                    background: #1d87e3;
                    border: 1px solid #2a86d5;
                    box-shadow: 0px 3px 6px 0px rgba(11, 44, 109, 0.16);
                }
            }
        }

        .ant-steps-item-wait {
            .ant-steps-item-icon {
                background: #ececec;

                .ant-steps-icon {
                    background: #eaeaea;
                    border: 1px solid rgba(213, 213, 213, 1);
                    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
                    color: #666666;
                }
            }
        }

        .ant-steps-item-finish {
            .ant-steps-item-icon {
                background: rgba(25, 195, 137, 0.12);

                .ant-steps-icon {
                    background: #19c389;
                    border: 1px solid rgba(41, 188, 138, 1);
                    box-shadow: 0px 3px 6px 0px rgba(20, 151, 106, 0.29);
                    color: #fff;
                    font-size: 24px;
                }
            }

            > .ant-steps-item-container {
                > .ant-steps-item-tail {
                    &::after {
                        background: #19c389;
                    }
                }
            }
        }

        .ant-steps-item {
            > .ant-steps-item-container {
                > .ant-steps-item-content {
                    margin-top: 0;
                    margin-left: 10px;
                    > .ant-steps-item-title {
                        font-size: 16px;
                        color: #333333;
                        letter-spacing: 0;
                        font-weight: 600;
                    }
                }

                > .ant-steps-item-tail {
                    top: 22px;
                    margin-left: 67px;

                    &::after {
                        height: 3px;
                    }
                }
            }
        }
    }
}

body .ant-spin {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba($color: #fff, $alpha: 0.6);
}
</style>
